import { ProductType } from "@obg/core.config";
import { fromMinutesToMilliseconds } from "@obg/ngx.global";

import { ACTION_PREFIX, RESPONSIBLE_GAMING_ACTION_TYPE } from "./responsible-gaming.action";
import { InstantSelfExclusionRequest, Timeout } from "./responsible-gaming.model";

export const RESPONSIBLE_GAMING_MESSAGE_CONTEXT = {
	loginAlert: `${ACTION_PREFIX} Login alert`,
	updateSelfExclusion: RESPONSIBLE_GAMING_ACTION_TYPE.updateSelfExclusionPeriod,
	updateCoolOff: RESPONSIBLE_GAMING_ACTION_TYPE.updateCoolOffPeriod,
	getSessionLimitCheckPeriod: `${ACTION_PREFIX} Get Session Time Limit Check Period`,
};

/**
 * Sets if a product should have reality check.
 */
export const REALITY_CHECK_ACTIVE_PRODUCT_MAP: Partial<Record<ProductType, boolean>> = {
	[ProductType.Casino]: true,
	[ProductType.LiveCasino]: true,
	[ProductType.VirtualSports]: true,
};

/**
 * If Session Time Limit and Reality Check popups would be both triggered within this interval,
 * consider them as overlapping and display only RC if customer is on Casino lobby.
 */
export const STL_RC_OVERLAPPING_IN_MS = fromMinutesToMilliseconds(1);

/**
 * Delay to make sure that RC triggers before STL when they would be overlapping.
 */
export const STL_RC_TOLERANCE_DELAY_IN_MS = 50;

/**
 * Default self-exclusion timeouts for period select.
 */
export const SELF_EXCLUSION_DEFAULT_TIMEOUTS: Timeout[] = [
	{ numberOfDays: 1, text: "self-exclusion.24-hours" },
	{ numberOfDays: 7, text: "self-exclusion.7-days" },
	{ numberOfDays: 30, text: "self-exclusion.1-month" },
	{ numberOfDays: 60, text: "self-exclusion.2-months" },
	{ numberOfDays: 180, text: "self-exclusion.6-months" },
	{ numberOfDays: 36525, text: "self-exclusion.indefinitely" },
];

/**
 * Default interval for indefinite timeout.
 */
export const INDEFINITE_SELF_EXCLUSION_DEFAULT_INTERVAL: Timeout[] = [
	{ numberOfDays: 1460, text: "self-exclusion.indefinitely" },
];

/**
 * Default coolOff timeouts for period select for UK legislation.
 */
export const COOL_OFF_DEFAULT_TIMOUTS: Timeout[] = [
	{ numberOfDays: 1, text: "self-exclusion.24-hours" },
	{ numberOfDays: 7, text: "self-exclusion.7-days" },
	{ numberOfDays: 30, text: "self-exclusion.1-month" },
	{ numberOfDays: 60, text: "self-exclusion.2-months" },
	{ numberOfDays: 90, text: "self-exclusion.3-months" },
];

export const RESPONSIBLE_GAMING_ROUTE = {
	root: "responsible-gaming",
	information: "responsible-gaming.information",
	bettingLimit: "responsible-gaming.betting-limit",
	netlossLimit: "responsible-gaming.netloss-limit",
	depositLimit: "responsible-gaming.deposit-limit",
	netDepositLimit: "responsible-gaming.net-deposit-limit",
	depositLimitCalculator: "responsible-gaming.deposit-limit-calculator",
	depositLimitDialog: "responsible-gaming.deposit-limit-dialog",
	balanceLimit: "responsible-gaming.balance-limit",
	selfExclusion: "responsible-gaming.self-exclusion",
	indefiniteSelfExclusion: "responsible-gaming.indefinite-self-exclusion",
	realityCheck: "responsible-gaming.reality-check",
	selfAssessment: "responsible-gaming.self-assessment",
	timeOff: "responsible-gaming.time-off",
	sessionLimit: "responsible-gaming.session-limit",
	sessionLimitDialog: "responsible-gaming.session-limit-dialog",
	selectPlayerProfile: "responsible-gaming.select-player-profile",
	underageGambling: "responsible-gaming.underage-gambling",
	casinoGamesWins: "responsible-gaming.casino-games-wins",
	logoutCooldown: "responsible-gaming.logout-cooldown",
	loginLimit: "responsible-gaming.login-limit",
	documentVerification: "responsible-gaming.document-verification",
};

export const PANIC_BUTTON_DEFAULT_TIMEOUT: Timeout = {
	numberOfDays: 1,
	text: "self-exclusion.24-hours",
};

export const TWELVE_HOUR_SELF_EXCLUSION: InstantSelfExclusionRequest = {
	minutes: 720,
};
